import { Location } from '@angular/common';
import { ElementRef, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HelpTopicViewerDialogComponent } from '../components/help-topic-viewer-dialog/help-topic-viewer-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class HelpTopicService {
  constructor(private location: Location, private matDialog: MatDialog) { }

  /**
   * This function receives a reference to the HTML element like a <form> that contains child HTML elements with a matBadge directive
   * @param elementRef 
   */  
  setupHelpTopics(elementRef: ElementRef) {
    const elements = elementRef.nativeElement.querySelectorAll('.mat-badge-content');
        
    elements?.forEach(element=> {
      if (element) {
        element.style.pointerEvents = 'inherit'; // Necessary to enable pointer events
        element.style.cursor = 'pointer';
        element.addEventListener('click', (e) => {
          const elementRect = element.getBoundingClientRect();
          const helpTopicKey = e.srcElement !== undefined ? e.srcElement.innerText : e.innerText;
          this.openHelpTopicViewerDialog(null, helpTopicKey, elementRect);
      });
      }
    });
  }

   /**
   * This function receives a reference to the HTML element like a <form> that contains child HTML elements with a matBadge directive
   * @param title : Title of dialog that will show the help topic
   * @param key : Key and part of the identifiers needed to get a specific help topic
   * @param sourceElementRectangle : Html rectangle of the source element. Used to show the help topic dialog completly left or right
   */ 
  openHelpTopicViewerDialog(title: string, key: string, sourceElementRectangle: any) {

    // Close existing Help Topic dialog before opening a new one
    this.matDialog.openDialogs?.forEach((d) => {
        if (d.componentInstance?.data?.domain === this.getCurrentDomain()) {
          d.close();
        }
    });

    // If the clickable help badge is on the right then we show the help dialog on the left and vice-versa
    const isClickableBadgeOnRight = (sourceElementRectangle.x > window.innerWidth/2);
    const dialogLeftPos= { left: `5px`, top: `5px` };
    const dialogRightPos= { right: `5px`, top: `5px` };    
    
    this.matDialog.open(HelpTopicViewerDialogComponent, {
      position: isClickableBadgeOnRight ? dialogLeftPos : dialogRightPos,
      hasBackdrop: false,
      panelClass: 'help-topic-viewer',
      data: {
        domain: this.getCurrentDomain(),
        title: title,
        key: key
      },
      disableClose: true
    });
  }

  getCurrentDomain(): string {
    const routeParts = this.location.path().split('/');
    if (routeParts[1] === 'company')
    {
      if (routeParts.length >= 4 && routeParts[3] === 'form' && routeParts[4] === 'annual')
        return `${routeParts[1]}/${routeParts[3]}/${routeParts[4]}`;
    }

    return routeParts[1];
  } 
}
